/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-console */
/* eslint-disable unicorn/no-nested-ternary */
/* eslint-disable complexity */
import PropTypes from 'prop-types';
import {
  DataTableBodyV2, DataTableV2, dlsGray06, Heading,
} from '@americanexpress/dls-react';
import React, { useEffect, useState } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { callFxgApi } from '../../../utils/callFxgApi';
import { useEnhancedDataTableContext } from './EnhancedDataTableContext';
import EnhancedHeader from './EnhancedHeader';
import { getClientEndFilteredRow, getClientEndOperationRow, getRows } from './DataTableRowUtil';
import EnhancedTableToolbar from './EnhancedTableToolbar/EnhancedTableToolbar';
import { EnhancedFilter } from './EnhancedTableFilter/EnhanceFilter';
import Pagination from '../Pagination';
import {
  callAPIHelper,
  getSelectedRowCnt,
  handleToggleChangeHelper,
  onFilterHelper,
  onFilterIconClickedHelper,
  onFilterResetHelper,
  onHeaderRowCheckChangeHelper,
  onHeaderRowCheckChangeHelperV2,
  onPageChangeHelper,
  onRowCheckChangeHelper,
  onSortClickHelper,
  onTableSettingResetToDefaultHelper,
  onTableSettingsChangeHelper,
  resetTableSelections,
} from './EnhanceDataTableUtil';
import ConfirmUserPopup from '../ConfirmUserPopup/ConfirmUserPopup';
import { getActiveHeader, getInActiveHeader, getPreferenceOrder } from './DataTableHeaderUtil';
import Loader from '../Loader';
import { notEqualCheck } from '../../utils/FsUtil';
import ExpandableType from '../../constants/ExpandableType';
import paths from '../../constants/paths';

const EnhancedTable = React.memo(() => {
  const context = useEnhancedDataTableContext();

  const { loginData } = context;
  const { apiHostService } = context;

  const { showError } = context;
  const { showToolBar = true } = context;
  const { checkable } = context;
  const { totalRows } = context;
  const { showLoader } = context;
  const { tableNm } = context;
  const { tableHeading } = context;
  const { isDisplayTableHeading } = context;

  const { rows } = context;
  const { headers } = context;
  const { singleRowSelect } = context;
  const { inlineItemAction = false } = context;
  const { sortDirection } = context;
  const { sortBy } = context;
  const { sortable } = context;
  const { showFilter } = context;
  const { rowKeyCol } = context;

  const { clientEndOperation } = context;

  const { onPageChange } = context;
  const { onRowCheckChange } = context;
  const { onHeaderRowCheckChange } = context;
  const { onHeaderPosChange } = context;
  const { onSortClick } = context;
  const { onTableSettingsChange } = context;
  const { onFilterIconClicked } = context;
  const { onFilter } = context;
  const { onFilterReset } = context;
  const { onTableSettingResetToDefault } = context;
  const { onItemsPerPageChange } = context;
  const { onItemActionClick } = context;
  const { onExportClick } = context;

  const { setTableData } = context;
  const { tableData } = context;

  const { fetchTableData } = context;
  const { disableCheckbox } = context;
  const { expandable } = context;
  const { striped = false } = context;
  const { bordered = true } = context;
  const { resetTableSelection } = context;
  const [showLoaderOnTable, setShowLoaderOnTable] = useState(false);

  let clientSideFilteredRow = [];
  let rowsForClientSideTable = [];

  if (clientEndOperation) {
    clientSideFilteredRow = getClientEndFilteredRow(tableData, loginData?.userDetail?.timeZone?.timeZoneLocation);
    rowsForClientSideTable = getClientEndOperationRow(clientSideFilteredRow, tableData);
  }

  const newTotalRows = clientEndOperation ? clientSideFilteredRow.length : totalRows;
  const itemInCurrentPage = clientEndOperation ? rowsForClientSideTable.length : rows.length;

  const isEmpty = !(newTotalRows > 0);

  const displayCheckBox = inlineItemAction ? false : checkable
    ? showError || showLoader || singleRowSelect ? false : !isEmpty
    : false;

  const handleExpandRowClick = (event, { id }) => {
    const newTableData = { ...tableData };
    let index = -1;
    if (notEqualCheck(newTableData.expandableType, ExpandableType.COMPONENT)) {
      index = newTableData.rows.findIndex((row) => row.columns[newTableData.rowKeyCol] === id);
    } else {
      index = newTableData.rows.findIndex((row) => row[newTableData.rowKeyCol] === id);
    }
    if (index !== -1) {
      const newRow = newTableData.rows[index];
      newRow.expandable = !newRow.expandable;
      newTableData.rows[index] = newRow;
      setTableData(newTableData);
    }
  };

  const handleSelectionReset = () => {
    resetTableSelections(context);
  };

  useEffect(() => {
    // If any headers have default values on start then show filters
    if (tableData?.headers?.some((header) => header?.filter)) {
      console.log('settingFilter to true');
      tableData.showFilter = true;
    }
  }, []);

  useEffect(() => {
    if (resetTableSelection) {
      handleSelectionReset();
    }
  }, [resetTableSelection]);

  // TODO: call checkableCondition in here
  const handleRowCheckChange = (e, data) => {
    let isCheckable = true;
    // Condition for checking Row selection change from Inline Action Menu
    if (inlineItemAction) {
      onRowCheckChangeHelper(tableData, data, setTableData, rowsForClientSideTable);
    }
    if (typeof disableCheckbox === 'function') {
      const rowData = rows.find((row) => {
        const rowId = row?.[rowKeyCol];
        return rowId === data?.id;
      });
      if (rowData) {
        isCheckable = !disableCheckbox(rowData);
        if (!isCheckable && singleRowSelect) {
          e.target.checked = false;
        }
      }
    }

    if (data.checked === false && isCheckable) {
      if (!singleRowSelect && getSelectedRowCnt(tableData) >= tableData.maxRowSelection) {
        const newTableData = { ...tableData };
        newTableData.maxRecordReached = true;
        setTableData(newTableData);
        return;
      }
    }
    if (isCheckable) {
      if (onRowCheckChange) {
        onRowCheckChange(e, data);
      } else {
        onRowCheckChangeHelper(tableData, data, setTableData, rowsForClientSideTable);
      }
    }
  };

  // TODO: call checkableCondition in here
  const handleHeaderRowCheckChange = (e, data) => {
    if (data.checked === false) {
      if (!singleRowSelect
        && (getSelectedRowCnt(tableData) + itemInCurrentPage) > tableData.maxRowSelection) {
        const newTableData = onHeaderRowCheckChangeHelperV2(tableData,
          data,
          setTableData,
          disableCheckbox,
          singleRowSelect);
        newTableData.maxRecordReached = true;
        setTableData(newTableData);
        return;
      }
    }
    if (onHeaderRowCheckChange) {
      onHeaderRowCheckChange(e, data);
    } else {
      onHeaderRowCheckChangeHelper(
        tableData,
        data,
        setTableData,
        disableCheckbox,
        handleRowCheckChange);
    }
  };

  const callAPI = async (updatedTableData, savePreferenceData = false) => {
    const {
      newRows,
      isError,
      hyperlinkData,
    } = await fetchTableData(
      updatedTableData, false, savePreferenceData);
    callAPIHelper(updatedTableData, newRows, setTableData, isError, hyperlinkData);
  };

  const savePreference = async (newTableData) => {
    const settingData = {
      tableNm,
      preferenceData: newTableData.preferceData,
    };
    // TODO: must not be specific to only access-management
    // eslint-disable-next-line no-unused-vars
    await callFxgApi(`${apiHostService}${paths.apiPaths.fxgSaveUserPreferenceData}`, 'POST', settingData);
  };

  const handleSortClick = async (e, columnId) => {
    const data = columnId.split('-cell-')[1] || columnId;
    if (onSortClick) {
      onSortClick(e, data);
    } else {
      if (tableData.preferceData) {
        tableData.preferceData.sortDirection = tableData.sortBy === data && tableData.sortDirection === 'asc' ? 'desc' : 'asc';
        tableData.preferceData.sortBy = data;
      }
      if (clientEndOperation) {
        onSortClickHelper(tableData, data, setTableData);
        if (loginData && apiHostService) {
          setShowLoaderOnTable(true);
          await savePreference(tableData);
          setShowLoaderOnTable(false);
        }
      } else {
        callAPI(onSortClickHelper(tableData, data, setTableData), true);
      }
    }
  };

  const handleFilterIconClicked = (displayFilters) => {
    if (onFilterIconClicked) {
      onFilterIconClicked(displayFilters);
    } else {
      onFilterIconClickedHelper(tableData, displayFilters, setTableData);
    }
  };

  const handleActionItemClicked = (actionId, selectedRows) => {
    if (onItemActionClick) {
      onItemActionClick(actionId, selectedRows);
    }
  };

  const handleExportClicked = (actionId) => {
    if (onExportClick) {
      onExportClick(actionId);
    }
  };

  const handleTableSettingsChange = (newPrefrenceData) => {
    if (onTableSettingsChange) {
      onTableSettingsChange(newPrefrenceData);
    } else if (clientEndOperation) {
      onTableSettingsChangeHelper(tableData, newPrefrenceData, setTableData, totalRows);
    } else {
      callAPI(onTableSettingsChangeHelper(tableData, newPrefrenceData, setTableData, totalRows));
    }
  };

  const handleTableSettingResetToDefault = (newPrefrenceData, newTableData) => {
    if (onTableSettingResetToDefault) {
      onTableSettingResetToDefault(newPrefrenceData);
    } else if (clientEndOperation) {
      onTableSettingResetToDefaultHelper(newTableData, newPrefrenceData, setTableData);
    } else {
      callAPI(onTableSettingResetToDefaultHelper(newTableData, newPrefrenceData, setTableData));
    }
  };

  const handleFilter = (filter) => {
    if (onFilter) {
      onFilter(filter);
    } else if (clientEndOperation) {
      onFilterHelper(tableData, filter, setTableData);
    } else {
      callAPI(onFilterHelper(tableData, filter, setTableData));
    }
  };

  const handleFilterReset = () => {
    if (onFilterReset) {
      onFilterReset();
    } else if (clientEndOperation) {
      onFilterResetHelper(tableData, setTableData);
    } else {
      callAPI(onFilterResetHelper(tableData, setTableData));
    }
  };

  const handleItemsPerPageChange = async (itemsPerPage, newPageNumber) => {
    if (onItemsPerPageChange) {
      onItemsPerPageChange(itemsPerPage, newPageNumber);
    } else {
      if (tableData.preferceData) {
        tableData.preferceData.itemsPerPage = itemsPerPage;
      }
      if (clientEndOperation) {
        onPageChangeHelper(tableData, itemsPerPage, newPageNumber, setTableData);
        if (loginData && apiHostService) {
          setShowLoaderOnTable(true);
          await savePreference(tableData);
          setShowLoaderOnTable(false);
        }
      } else {
        callAPI(onPageChangeHelper(tableData, itemsPerPage, newPageNumber, setTableData), true);
      }
    }
  };

  const handlePageChange = (itemsPerPage, newPageNumber) => {
    if (onPageChange) {
      onPageChange(itemsPerPage, newPageNumber);
    } else if (clientEndOperation) {
      onPageChangeHelper(tableData, itemsPerPage, newPageNumber, setTableData);
    } else {
      callAPI(onPageChangeHelper(tableData, itemsPerPage, newPageNumber, setTableData));
    }
  };

  const handleHeaderPosChange = async (newHeaders) => {
    if (onHeaderPosChange) {
      onHeaderPosChange(newHeaders);
    } else {
      const newTableData = { ...tableData };
      newTableData.headers = [...newHeaders];
      if (newTableData.preferceData) {
        newTableData.preferceData.inactiveHeader = getInActiveHeader(newHeaders);
        newTableData.preferceData.activeHeader = getActiveHeader(newHeaders);
        newTableData.preferceData.order = getPreferenceOrder(newHeaders);
        if (loginData && apiHostService) {
          setShowLoaderOnTable(true);
          await savePreference(newTableData);
          setShowLoaderOnTable(false);
        }
      }
      setTableData(newTableData);
    }
  };

  const onUserConfirm = () => {
    const newTableData = { ...tableData };
    newTableData.maxRecordReached = false;
    setTableData(newTableData);
  };

  const handleToggleChange = (e, data) => {
    handleToggleChangeHelper(tableData, data, setTableData, rowsForClientSideTable);
  };

  const rowsMarkup = getRows(
    loginData,
    tableData,
    isEmpty,
    clientEndOperation ? rowsForClientSideTable : rows,
    handleRowCheckChange,
    disableCheckbox,
    handleToggleChange,
    handleActionItemClicked
  );

  return (
    <>
      {(isDisplayTableHeading == null || isDisplayTableHeading) && (
        <Heading id={`${tableNm}-tableTitle`} level={2} theme={dlsGray06} headingStyle="heading5">
          {tableHeading}
        </Heading>
      )}

      <Loader showLoader={showLoaderOnTable} />

      <ConfirmUserPopup
        displayPopup={tableData.maxRecordReached}
        onConfirm={onUserConfirm}
        confirmLabel="Ok"
        message={tableData.maxRowSelectionErrMsg}
        header=""
      />
      {showToolBar && (
        <EnhancedTableToolbar
          totalRows={newTotalRows}
          itemInCurrentPage={itemInCurrentPage}
          onTableSettingsChange={handleTableSettingsChange}
          onTableSettingResetToDefault={handleTableSettingResetToDefault}
          onItemsPerPageChange={handleItemsPerPageChange}
          onFilterIconClicked={handleFilterIconClicked}
          onItemActionClick={handleActionItemClicked}
          handleRowCheckChange={handleRowCheckChange}
          onExportClick={handleExportClicked}
        />
      )}
      {!showToolBar && <div id="tableToolbar" className="col-md-12 pad-1" />}

      {showFilter && (
        <DataTableV2
          id={tableNm}
          bordered={bordered}
          striped={striped}
          expandable={expandable}
          onExpandRowClick={handleExpandRowClick}
          checkable={displayCheckBox}
          onHeaderRowCheckChange={handleHeaderRowCheckChange}
          onRowCheckChange={handleRowCheckChange}
          onSortClick={handleSortClick}
          sortDirection={sortDirection === 'asc' ? 'ascending' : 'descending'}
          sortBy={`${tableNm}-cell-${sortBy}`}
          sortable={sortable}
          style={{
            whiteSpace: 'break-spaces',
            wordBreak: 'normal',
          }}
        >
          <EnhancedHeader isEmpty={isEmpty} onHeaderPosChange={handleHeaderPosChange} />
          <DataTableBodyV2
            id={`${tableNm}-body`}
            theme={{
              whiteSpace: 'break-spaces',
              wordBreak: 'break-all',
            }}
          >
            {headers && (
              <EnhancedFilter
                key={showFilter}
                onFilter={handleFilter}
                onFilterReset={handleFilterReset}
              />
            )}
            {[rowsMarkup]}
          </DataTableBodyV2>
        </DataTableV2>
      )}

      {!showFilter && (
        <DataTableV2
          id={tableNm}
          bordered={bordered}
          striped={striped}
          expandable={expandable}
          onExpandRowClick={handleExpandRowClick}
          checkable={displayCheckBox}
          onHeaderRowCheckChange={handleHeaderRowCheckChange}
          onRowCheckChange={handleRowCheckChange}
          onSortClick={handleSortClick}
          sortDirection={sortDirection === 'asc' ? 'ascending' : 'descending'}
          sortBy={`${tableNm}-cell-${sortBy}`}
          sortable={sortable}
          style={{
            whiteSpace: 'break-spaces',
            wordBreak: 'normal',
          }}
        >
          <EnhancedHeader isEmpty={isEmpty} onHeaderPosChange={handleHeaderPosChange} />
          <DataTableBodyV2
            id={`${tableNm}-body`}
            theme={{
              whiteSpace: 'break-spaces',
              wordBreak: 'break-all',
            }}
          >{rowsMarkup}
          </DataTableBodyV2>
        </DataTableV2>
      )}

      <EnhancedPagination
        onPageChange={handlePageChange}
        totalRows={newTotalRows}
        tableNm={tableNm}
      />
    </>
  );
});

EnhancedTable.displayName = 'EnhancedTable';
export default EnhancedTable;

const EnhancedPagination = React.memo((props) => {
  const {
    onPageChange,
    totalRows,
    tableNm,
  } = props;

  const context = useEnhancedDataTableContext();

  const {
    itemsPerPage,
    paginationType = 'primary',
  } = context;
  const { currentPage } = context;

  const displayPagination = totalRows > 0;

  if (!displayPagination) return null;

  const totalPage = Math.ceil(totalRows / itemsPerPage);
  const currentSelectedPage = currentPage > totalPage ? totalPage : currentPage;

  return (
    <div style={{
      display: 'flex',
      flexFlow: 'row wrap',
      width: '100%',
      backgroundColor: '#f7f8f9',
    }}
    >
      <div
        id={`${tableNm}-pagination-start-style-div`}
        style={{
          width: '16.5%',
          flexShrink: 0,
          backgroundColor: '#f7f8f9',
        }}
      />
      <div
        id={`${tableNm}-pagination-container-div`}
        style={{
          flexGrow: 1,
          overflow: 'hidden',
        }}
      >
        <Pagination
          id={`${tableNm}-pagination`}
          type={paginationType}
          selected={currentSelectedPage}
          onChange={(newPageNumber) => {
            onPageChange(itemsPerPage, newPageNumber);
          }}
          total={totalPage}
          theme={{
            wordWrap: 'normal',
          }}
        />
      </div>
      <div
        id={`${tableNm}-pagination-end-style-div`}
        style={{
          width: '16.5%',
          flexShrink: 0,
          backgroundColor: '#f7f8f9',
        }}
      />
    </div>
  );
});

EnhancedPagination.displayName = 'EnhancedPagination';

EnhancedPagination.propTypes = {
  onPageChange: PropTypes.func.isRequired,
  totalRows: PropTypes.number.isRequired,
  tableNm: PropTypes.string.isRequired,
};
